import { render, staticRenderFns } from "./CameraStream.vue?vue&type=template&id=66885106&scoped=true"
import script from "./CameraStream.vue?vue&type=script&lang=js"
export * from "./CameraStream.vue?vue&type=script&lang=js"
import style0 from "./CameraStream.vue?vue&type=style&index=0&id=66885106&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66885106",
  null
  
)

export default component.exports